import { createTheme } from "@mui/material/styles";
import { COLORS } from "../utils/constants";

const theme = createTheme({
  palette: {
    background: {
      default: COLORS.ARCTIC,
      paper: COLORS.ARCTIC,
    },
    primary: {
      main: COLORS.MIDNIGHT,
    },
    secondary: {
      main: COLORS.FIERY,
    },
    text: {
      primary: COLORS.MIDNIGHT,
      secondary: COLORS.MIDNIGHT_70,
    },
  },

  typography: {
    fontFamily: "Inter, sans-serif",
    button: {
      fontWeight: 600,
      textTransform: "none",
    },
  },

  shape: {
    borderRadius: 12,
  },

  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          padding: "10px 22px",
          fontWeight: 600,
          transition: "all 0.25s ease",
          boxShadow: "none",
          "&:active": {
            transform: "scale(0.98)",
          },
        },

        containedSecondary: {
          backgroundColor: COLORS.FIERY,
          boxShadow: "0 6px 14px rgba(233,79,55,0.25)",
          "&:hover": {
            backgroundColor: COLORS.FIERY_HOVER,
            boxShadow: "0 10px 24px rgba(233,79,55,0.35)",
            transform: "translateY(-1px)",
          },
        },

        outlinedPrimary: {
          borderColor: COLORS.MIDNIGHT,
          color: COLORS.MIDNIGHT,
          "&:hover": {
            backgroundColor: "rgba(57,62,65,0.05)",
            borderColor: COLORS.MIDNIGHT,
            transform: "translateY(-1px)",
          },
        },
      },
    },
  },
});

export default theme;
